import { getVisitorInformationQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/visitorKeys.js';
import { getVisitorInformation } from '#pplx/frontend/apps/ask/queries/visitor-queries/getVisitorInformation.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export const useGetVisitorInformation = ({ enabled = true, reason, }) => {
    return useQuery({
        queryKey: getVisitorInformationQueryKey(),
        queryFn: () => getVisitorInformation({ reason }),
        enabled,
    });
};
export const useIncrementVisitorDailyQueryCount = () => {
    const queryClient = useQueryClient();
    return useCallback(() => {
        const queryKey = getVisitorInformationQueryKey();
        const currentData = queryClient.getQueryData(queryKey);
        if (currentData !== undefined) {
            // Data exists in cache, increment immediately
            queryClient.setQueryData(queryKey, {
                visitor_queries_past_day: currentData.visitor_queries_past_day + 1,
            });
        }
        else {
            // No data yet, wait for query to resolve then increment
            queryClient
                .ensureQueryData({
                queryKey,
                queryFn: () => getVisitorInformation({ reason: 'increment-wait-for-cache' }),
            })
                .then((data) => {
                queryClient.setQueryData(queryKey, {
                    visitor_queries_past_day: data.visitor_queries_past_day + 1,
                });
            })
                .catch(() => {
                // If fetch fails, silently ignore - we don't want to block the query
            });
        }
    }, [queryClient]);
};
//# sourceMappingURL=useGetVisitorInformation.js.map